
export const formatNumber = (n) =>
    typeof n === "number" ? n.toLocaleString() : n ?? "-";

export const capitalize = (str) =>
    typeof str === "string" && str.length
        ? str.charAt(0).toUpperCase() + str.slice(1)
        : str;

export const getUsagePercent = (used, total) => {
    if (!total) return 0;
    return Math.min((used / total) * 100, 100);
};

export const formatDate = (isoString, options = { year: "numeric", month: "short", day: "numeric" }) =>
    isoString ? new Date(isoString).toLocaleDateString(undefined, options) : "-";

export const formatRelativeTime = (isoString) => {
    if (!isoString) return "-";
    const diffMs = Date.now() - new Date(isoString).getTime();
    const diffSec = Math.round(diffMs / 1000);
    const diffMin = Math.round(diffSec / 60);
    const diffHr = Math.round(diffMin / 60);
    const diffDay = Math.round(diffHr / 24);

    if (diffSec < 60) return "Just now";
    if (diffMin < 60) return `${diffMin} minute${diffMin === 1 ? "" : "s"} ago`;
    if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? "" : "s"} ago`;
    if (diffDay < 7) return `${diffDay} day${diffDay === 1 ? "" : "s"} ago`;
    return formatDate(isoString);
};

export const formatCurrency = (amount, currency = "USD") =>
    typeof amount === "number"
        ? new Intl.NumberFormat(undefined, {
            style: "currency",
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(amount)
        : "-";


export const buildBrokerageLimits = (limits = {}, icons = {}) => [
    { label: "RATE LIMIT", value: limits.rateLimit, icon: icons.rateLimit },
    { label: "DATA HISTORY", value: limits.dataHistory, icon: icons.dataHistory },
    { label: "DATA FREQUENCY", value: limits.dataFrequency, icon: icons.dataFrequency },
    { label: "DATA FORMAT", value: limits.dataFormat, icon: icons.dataFormat },
];


export const SIDEBAR_CONFIG = {
    individual: ["Profile", "Plan", "Modules", "Billing"],
    org_corporate: [
        "Profile",
        "Plan",
        "Team",
        "Workspaces",
        "Notifications",
        "Billing",
    ],
    org_brokerage: ["Profile", "Plan", "Billing"],
};


export const getSidebarTabs = (userType, tier, role) => {
    const base = SIDEBAR_CONFIG[userType] || SIDEBAR_CONFIG.org_corporate;

    return base.filter((tab) => {
        if (tab === "Billing") return tier === "paid";
        if (tab === "Notifications") {
            return userType === "org_corporate" && tier === "paid" && role === "owner";
        }
        return true;
    });
};

export const groupNotificationsByRead = (items = []) => ({
    unread: items.filter((n) => !n.isRead),
    read: items.filter((n) => n.isRead),
});

export const slugify = (str = "") =>
    str
        .trim()
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

export const buildWorkspaceUrl = (baseUrl, orgName, workspaceName) =>
    `${baseUrl}/org/${slugify(orgName)}/workspace/${slugify(workspaceName)}`;


export const deriveOrgRole = (member) => {
    if (member.orgRole) return member.orgRole;
    const roleValues = Object.values(member.roles || {});
    if (roleValues.length > 0 && roleValues.every((r) => r === "Owner")) return "owner";
    if (roleValues.some((r) => r === "Admin")) return "admin";
    return "member";
};


export const MODULE_NAME_TO_KEY = {
    Screener: "screener",
    Analytics: "analytics",
    "Risk Map": "risk_map",
    "Accounting Policies and Notes": "accounting_policies",
    Benchmarking: "benchmarking",
    "Super Investors - US": "super_investors_us",
    Watchlist: "watchlist",
    Portfolio: "portfolio",
};

export const getOwnedModuleKeys = (hasAccess = []) =>
    hasAccess.map((m) => MODULE_NAME_TO_KEY[m.name]).filter(Boolean);

// ---- Workspaces ----
export const buildWorkspaceMeta = (item) => {
    const memberCount = item.membersCount ?? 0;
    const memberLabel = `${memberCount} member${memberCount === 1 ? "" : "s"}`;
    if (item.hasAccess) {
        return `${memberLabel} · ${item.description} · You: ${item.yourRole}`;
    }
    return `${memberLabel} · ${item.description}`;
};

export const normalizeUserType = (raw) => {
    switch (raw) {
        case "individual": return "individual";
        case "org_corporate":
        case "org-corporate": return "org_corporate";
        case "org_brokerage":
        case "org-brokerage":
        case "prg_brokerage": return "org_brokerage";
        default: return null;
    }
};